import { Link } from 'react-router-dom';
import { RotateCcw } from 'lucide-react';
import { StaticPageLayout } from '../../components/shopper/StaticPageLayout';
import { Card, CardContent } from '../../components/ui/card';
import { buttonVariants } from '../../components/ui/button';
import { cn } from '../../lib/utils';
import { RETURNS_SECTIONS } from '../../content/site-pages';
import { ROUTES } from '../../constants/routes';

export function ReturnsPage() {
  return (
    <StaticPageLayout
      title="Returns & Exchanges"
      subtitle="Policies vary by boutique — check before you buy"
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
          <RotateCcw className="h-5 w-5 text-primary" />
        </div>
        <p className="text-sm text-body leading-relaxed">
          Each boutique on Fash sets its own return policy. You will see the applicable policy
          on the product page before checkout. Most partners accept returns within 14–30 days
          for unworn items with tags attached.
        </p>
      </div>

      <Card>
        <CardContent className="p-0 divide-y divide-gray-100">
          {RETURNS_SECTIONS.map((item) => (
            <div key={item.question} className="p-5">
              <h2 className="font-medium text-heading text-sm mb-2">{item.question}</h2>
              <p className="text-sm text-body leading-relaxed">{item.answer}</p>
            </div>
          ))}
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-5 text-center space-y-3">
          <p className="text-sm text-body">
            Need to start a return or report an issue with a recent order?
          </p>
          <Link to="/orders" className={cn(buttonVariants(), 'rounded-full inline-flex')}>
            View your orders
          </Link>
        </CardContent>
      </Card>

      <p className="text-sm text-body text-center">
        Still have questions?{' '}
        <Link to={ROUTES.contact} className="text-primary hover:underline">
          Contact support
        </Link>
        .
      </p>
    </StaticPageLayout>
  );
}
